import { Workbox } from 'workbox-window';
import { signal } from '@preact/signals';

/**
 * Регистрация service worker через workbox-window.
 * Сохраняет ServiceWorkerRegistration в сигнал — он нужен для push (pushManager).
 */

// Текущая регистрация SW (или null, если SW не поддержан / не зарегистрирован).
export const swRegistration = signal(null);
// Флаг доступности офлайн-режима (SW закэшировал ассеты).
export const offlineReady = signal(false);

let workbox = null;

export function initPWA() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  // В dev (vite, http://localhost) SW отключён через devOptions — /sw.js не существует.
  if (import.meta.env && import.meta.env.DEV) {
    return;
  }

  workbox = new Workbox('/sw.js');

  // Перезагружаем страницу только при ОБНОВЛЕНИИ SW (не при первой установке),
  // чтобы пользователь сразу получил свежий билд после autoUpdate.
  workbox.addEventListener('controlling', (event) => {
    if (event.isUpdate) {
      window.location.reload();
    }
  });

  workbox.addEventListener('activated', (event) => {
    if (!event.isUpdate) {
      offlineReady.value = true;
    }
  });

  workbox
    .register()
    .then((reg) => {
      swRegistration.value = reg || null;
    })
    .catch((err) => {
      // Не критично — приложение работает и без SW.
      console.warn('[PWA] SW registration failed:', err);
    });
}

/**
 * Возвращает готовую регистрацию SW (ждёт, если ещё не зарегистрирован).
 * Используется клиентом push-подписки.
 */
export async function getSWRegistration() {
  if (swRegistration.value) return swRegistration.value;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    swRegistration.value = reg;
    return reg;
  } catch {
    return null;
  }
}
